import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Switch from 'component/Switch'

const DEPOSIT_DESCRIPTIONS = {
  'C010': 'Depósito',
  'C050': 'Loja',
  'C060': 'Saldo',
  'C070': 'Mostruário',
  'C080': 'Devolução'
}

const formatDepositWithDescription = (depositCode) => {
  if (!depositCode) return ''
  
  const upperCode = depositCode.toUpperCase()
  const description = DEPOSIT_DESCRIPTIONS[upperCode]
  
  return description ? `${upperCode} - ${description}` : upperCode
}

const DepositTable = ({
  deposits,
  onToggleRequiresApproval,
  updatingIds = [],
}) => {
  const tableRef = useRef(null)
  const [height,setHeight] = useState(0)
  const PAGINATION_HEIGHT = 71
  const TOP_ACTIONS = 95
  const TOP_BAR = 67 + 50

  useEffect(() => {
    setHeight(window.innerHeight)
    const calculateHeight = () => {
      setHeight(window.innerHeight)}
    window.addEventListener("resize", calculateHeight)
    return () => window.removeEventListener("resize", calculateHeight)
  }, [])

  useEffect(() => {

    if(height < 868 && height !== 0) {
      const responsiveHeight = height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 80)
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `${responsiveHeight}px`
    }
    else if(height > 947) {
      const responsiveHeight = height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 80)
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `${responsiveHeight}px`
    }
 

    // Add margin bottom for smaller screens
    const stockTable = document.querySelector('.stock-adjustment-table.new')
    if(stockTable) {
      if(height < 768 && height !== 0) {
        stockTable.style.marginBottom = '20px'
      } else {
        stockTable.style.marginBottom = ''
      }
    }
  }, [height])

  const renderHeader = () => (
      <tr className='pictograms-tr'>
       <th style={{width: "33%"}} >Depósito origem</th>
       <th style={{width: "33%"}} >Depósito destino</th>
       <th style={{width: "34%"}} >Solicita aprovação</th>
      </tr>
    )

  const renderBody = () => {

    const renderRecord = (record) => {
      const { idWarehouseApproval, requiresApproval, sourceWarehouse, destinationWarehouse } = record
      const isUpdating = updatingIds.includes(idWarehouseApproval)

      return (
        <tr key={idWarehouseApproval}>
        
        <td className='CellWithComment' style={{width: "33%"}} > 
          <span className='list-description'>{formatDepositWithDescription(sourceWarehouse)}</span>
        </td>
        <td style={{width: "33%"}} >
          {formatDepositWithDescription(destinationWarehouse)}
        </td>
        <td style={{width: "34%", fontSize: '14px'}} >  
         
          <Switch 
            defaultValue={requiresApproval}
            disabled={isUpdating}
            onChange={() => onToggleRequiresApproval(idWarehouseApproval, !requiresApproval)}
          />
           <span style={{verticalAlign: "middle", paddingRight: "5px"}}>{requiresApproval ? "Sim" : "Não"}</span>
          
        </td>
        
        </tr>
      
      )
    }

    return deposits.map(renderRecord)
  }

  return (
    <table  cellPadding={0} cellSpacing={0} className={`supply-list-table-new new pictograms-table }`}>
      <thead ref={tableRef}>{renderHeader()}</thead>
      <tbody className='tbody-mission-block'  onScroll={(e) => {
        if(e.currentTarget.scrollTop > 20) {
          tableRef.current.classList.add("shadow-table-header-mission-block")
        }
        else {
          tableRef.current.classList.remove("shadow-table-header-mission-block")
        }
      }} >{renderBody()}</tbody>
      <tfoot style={{height: "1px",background:"#D3D2D6"}}></tfoot>
    </table>
  )
}

DepositTable.propTypes = {
  deposits: PropTypes.array.isRequired,
  onToggleRequiresApproval: PropTypes.func.isRequired,
  updatingIds: PropTypes.array,
}

export default DepositTable